<template>
  <div id="specoalPage">
    <component :is="Comname" :visible.sync= "show"></component>
  </div>
</template>
 
<script>
export default {
  data () {
    return {
      show: true
    }
  },
  computed: {
    Comname () {
      let queryName = this.$route.query.name ? this.$route.query.name : 'ePage'
      return () => import('./components/' + queryName + '.vue')
    }
  }
  // mounted () {
  //   this.Comname = this.$route.query.name ? this.$route.query.name : 'ePage'
  // }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/app_specialPage/index.vue